import React from 'react';

// Which entity's Insights view the gadgets rendered below belong to.
//
// Gadget data hooks are generic — they run inside reports, dashboards, the Explore
// modal, gadget-preview modals and Storybook — so they can't assume the
// currently-registered Insights entity is theirs. A popup report opened over a
// dashboard is the case that matters: InsightsContentContext.current is still the
// dashboard, so registering the popup's numbers against it would attribute one
// piece of content's figures to another.
//
// entityId is null everywhere this doesn't apply, and registration then no-ops.
const InsightsViewScopeContext = React.createContext<{
  entityId: string | null;
}>({ entityId: null });

export default InsightsViewScopeContext;
